import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { has, pickBy, size } from "lodash";
import { UploadProgress } from "./UploadProgress";
import { clearUploads } from "../../store/uploadSlice";


const UploadProgressContainer = (props) => {
    const uploads = useSelector(state => pickBy(state.upload.uploads, up => has(up, "type")));
    const dispatch = useDispatch();


    return(size(uploads)
        ? <UploadProgress
            uploads={uploads}
            onClearUploads={() => dispatch(clearUploads())}
        />
        : null
    );
};

export { UploadProgressContainer };